import { getRelativePath } from 'base/shared/Utils';

const BASE_PATH = '/settings';

export const getSepaDirectDebitPath = () => getRelativePath(`${BASE_PATH}/sepa`);

export const getSettingsPath = () => getRelativePath(BASE_PATH);
